// // The file contents for the current environment will overwrite these during build.
// // The build system defaults to the dev environment which uses `environment.ts`, but if you do
// // `ng build --configuration=uat` then `environment.uat.ts` will be used instead.
// // The list of which env maps to which file can be found in `angular.json`.
//

import { menuLinkNames } from '../app/constants/application-constants';

export const cdnBaseUrl = 'https://dev-cdn.hill-laboratories.com/';

export const environment = {
    production: false,
    cartId: 'cartId',
    restBaseURL: 'https://djrdm7fptd.execute-api.ap-southeast-2.amazonaws.com/dev',
    apiServicesDomain: 'https://djrdm7fptd.execute-api.ap-southeast-2.amazonaws.com/dev',
    nzPostPublicApiKey: '7cc1879c-ad81-4efd-88ac-b42775912667',
    cdnCatalogueImageUrl: `${cdnBaseUrl}images/catalogueitem/`,
    cdn60x60Images: '60x60/',
    cdn300x300Images: '300x300/',
    useUniversalLogin: false,
    environment: 'dev',
    hiddenLinks: [],
    honeyBlendingGroupName: 'Honey Blending',
    honeyForecastingGroupName: 'Honey Forecasting',
    honeyBlendingUrl: 'https://uat-blending.hill-laboratories.com/',
    honeyForecastingUrl: 'https://uat-forecasting.hill-laboratories.com/',
    windcaveUrl: 'https://uat.windcave.com/pxmi3/',
    showPersonaOptions: true,
    checkAccountVerification: true,
    showLogoutAfterCheckout: false,
    enableAlternateLayout: true,
    appLandingPage: 'catalogue/category',
    googleTagManager: {
        trackingId: 'GTM-P92Z7VS'
    },
    recaptchaKey: '6Lc5wB8pAAAAACbKGX69oAYS1And8P8eVcrTWOid',
    javaOverrideURL: '',
    sentryDsn: 'https://048290c9e712846b4aaea064fb3bf8fa@o4509902856978432.ingest.us.sentry.io/4510541344866304',
    sentryRelease: 'aa037dd197599e933fae3d4db825a8732a58a5ce',
    /* ---------------------- favourite -----------------------------*/
    favouritesHost: 'https://djrdm7fptd.execute-api.ap-southeast-2.amazonaws.com/dev',
    favouriteBaseURL: '/catalogue-item',
    accountLoginHost: 'https://djrdm7fptd.execute-api.ap-southeast-2.amazonaws.com/dev',
    apiKey: 'cOhh5aewCM9uMUN4lOah65Ep7KgzBsfa4lDb0CZO',

    /* ---------------------- c-sharp -----------------------------*/
    csBaseURL: 'https://djrdm7fptd.execute-api.ap-southeast-2.amazonaws.com/dev/cs',
    orderHistoryBaseUrl: 'https://djrdm7fptd.execute-api.ap-southeast-2.amazonaws.com/dev',
    /* ---------------------- register -----------------------------*/
    registerHost: 'https://djrdm7fptd.execute-api.ap-southeast-2.amazonaws.com/dev/cs',

    /* ---------------------- MyLab Service -----------------------------*/
    myLabBaseUrl: 'https://dev-api.hill-laboratories.com/mylab'
    // myLabBaseUrl: 'http://localhost:5122'
};
